export class EoProgressExclusionList {
  id: number;
  modAbbreviation: string;
  modNumber: string;
  enteredAt: Date;
  enteredBy: string;
}
